import { createContext } from "react";

export const LeaderboardContext = createContext(null);